import Cookies from 'js-cookie';

/**
 * Drop-in replacement for the SDK's default browser cookie token store
 * (browserCookieStore) that additionally sets the cookie Domain (e.g.
 * `.freedomly.io`), so one login session is shared between freedomly.io and
 * en.freedomly.io. Used only when REACT_APP_COOKIE_DOMAIN is configured;
 * without it the SDK's own default store is used.
 *
 * NOTE: sharing requires every instance to use the same
 * REACT_APP_SHARETRIBE_SDK_CLIENT_ID — the cookie name embeds the client ID
 * and Marketplace API tokens are issued per client.
 */
export const createCookieTokenStore = ({ clientId, secure, domain }) => {
  const expiration = 30; // days, matches the SDK's browserCookieStore
  const key = `st-${clientId}-token`;

  const secureFlag = secure ? { secure: true } : {};
  const domainFlag = domain ? { domain } : {};

  const getToken = () => {
    const cookie = Cookies.get(key);
    if (!cookie) {
      return null;
    }
    try {
      return JSON.parse(cookie);
    } catch (e) {
      return null;
    }
  };

  const setToken = tokenData => {
    if (domain) {
      // Expire a pre-migration host-only cookie: with duplicate cookie names
      // the browser keeps sending the older host-only value first, which
      // would shadow the shared domain-wide cookie.
      Cookies.remove(key);
    }
    Cookies.set(key, JSON.stringify(tokenData), {
      expires: expiration,
      ...secureFlag,
      ...domainFlag,
    });
  };

  const removeToken = () => {
    Cookies.remove(key);
    if (domain) {
      Cookies.remove(key, { ...domainFlag });
    }
  };

  return {
    getToken,
    setToken,
    removeToken,
  };
};
